export default __webpack_public_path__ + "static/media/UploadToCloud.d288a4cc.svg";